/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 12 */
'use strict';

var trackingUtils = require('../../modules/utils/tracking.utils');
var fieldUtils = require('../../modules/utils/field.utils');
const paymentInstrument = require('od-modules/utils/payment_instrument');

var $deleteHint;
var creditCardMap = {
    ccnumber: 'creditCardNumber',
    cardExpirationMonth: 'expirationDateMonth',
    cardExpirationYear: 'expirationDateYear',
    nameoncard: 'owner',
    code: 'creditCardType.creditCardCode',
    name: 'creditCardType.creditCardName',
    method: 'creditCardType.creditCardType',
};
var storeCreditCardInputs = ['nameoncard', 'ccnumber', 'cardExpirationMonth', 'cardExpirationYear'];

var getCreditCardModel = function(isDefault) {
    return {
        creditCardNumber: '',
        expirationDateMonth: '',
        expirationDateYear: '',
        owner: '',
        creationDate: Date.now(),
        modifiedDate: null,
        lastUsageDate: null,
        isDefault: isDefault,
        creditCardType: {
            creditCardType: '',
            creditCardName: '',
            creditCardCode: '',
        },
    };
};

var stopPropagationAndGetTarget = function(e) {
    e.stopPropagation();
    e.preventDefault();
    return $(e.target);
};

var isValidDate = function(year, month) {
    var today = new Date();
    var comparisonDate = new Date(today.getFullYear(), today.getMonth() + 1);
    var cCardExpDate = new Date('20' + year, month);

    return cCardExpDate >= comparisonDate;
};

var getAvailableCreditCardObj = function(paymentCCList, availablePaymentCCList, cc) {
    return {
        paymentInstrumentToken: cc.paymentInstrumentToken,
        id: cc.paymentInstrumentToken,
        code: cc.creditCardType.creditCardCode,
        name: cc.creditCardType.creditCardName,
        ccnumber: cc.creditCardNumber,
        cardExpirationMonth: cc.expirationDateMonth,
        cardExpirationYear: cc.expirationDateYear,
        nameoncard: cc.owner,
        ccvLimit: this.getCvvLength(cc.creditCardType.creditCardCode),
        isValid: Odigeo._.indexOf(availablePaymentCCList, cc.creditCardType.creditCardCode) > -1,
        lastCCNumbers: Odigeo._.reduce(Odigeo._.takeRight(cc.creditCardNumber, 4), function(a, b) {
            return a.concat(b);
        }),
        fee: (Odigeo._.find(paymentCCList, {code: cc.creditCardType.creditCardCode}) || {}).fee,
    };
};

var onModalTransitioned = function(isDisplayed, fn) {
    this.$cachedSelectors.removeCCModal.toggleClass('active', isDisplayed).one('transitionend', fn);
};

module.exports = {
    controller: {
        initController: function() {
            this.model.set({
                saveCardDataAcceptance: false,
                selectedStorageCreditCard: null,
            });
            this.model
                .on('change:storedCCList', this.model.updateCards, this.model)
                .on('change:availablePaymentCCList', this.model.updateCards, this.model)
                .on('change:selectedStorageCreditCard', this.model.selectStorageCreditCard, this.model)
                .on('change:storedCCListValid', this.view.displayStoredCC, this.view)
                .on('change:chosenMethod', this.view.chosenMethodChanged, this.view);
        },
    },
    model: {
        setCreditCards: function(data) {
            let validCCList = [];

            if (Odigeo._.isObject(data) && Odigeo._.isObject(data.userDTO)) {
                validCCList = _.filter(data.userDTO.creditCards, function(cc) {
                    return isValidDate(cc.expirationDateYearFormated, cc.expirationDateMonth);
                });
                if (Odigeo._.isArray(validCCList) && !validCCList.length) {
                    this.widget.view.trackPaymentsDisplayed(false, true);
                }
            }

            this.set('storedCCList', validCCList);
        },
        updateCards: function() {
            var paymentCCList = this.get('availablePaymentCCList');
            var availablePaymentCCList = Odigeo._.pluck(paymentCCList, 'code');
            var storedCCList = this.get('storedCCList');
            var storedCCListValid = [];

            if (Odigeo._.isArray(storedCCList) && storedCCList.length && Odigeo._.isArray(availablePaymentCCList) && availablePaymentCCList.length) {
                storedCCListValid = Odigeo._.map(storedCCList, function(cc) {
                    return Odigeo._.bind(getAvailableCreditCardObj, this, paymentCCList, availablePaymentCCList, cc)();
                }.bind(this));
            }
            this.set('storedCCListValid', storedCCListValid);
        },
        isStoredCardsAvailability: function() {
            return !!(this.get('storedCCListValid') || []).length;
        },
        getSelectedStorageCreditCard: function() {
            return this.get('selectedStorageCreditCard');
        },
        selectStorageCreditCard: function() {
            var cc = this.get('selectedStorageCreditCard');

            if (cc !== null) {
                var creditCardData = Odigeo._.reduce(storeCreditCardInputs, function(obj, field) {
                    obj[field] = cc ? cc[field] : '';
                    return obj;
                }, this.get('creditCardData'));
                this.set('creditCardData', creditCardData);
                this.saveCreditCardFields(creditCardData);
                cc = cc || this.defaultCreditCard || {};
                this.widget.setCreditCardType(cc.code);
                this.addItemToPricemanagerCollection({
                    concept: cc.code,
                    allPrice: cc.fee,
                    onePrice: cc.fee,
                    method: 'CREDITCARD',
                    quantity: this.widget.options.numTravellers,
                    type: 'CC_FEE',
                });
                Odigeo.trigger(this.widget.id + ':storedCardChanged', cc.name);

                this.widget.view.fillCvv();
            }
        },
        isStoredCardSelected: function() {
            var cc = this.get('selectedStorageCreditCard');
            if (Odigeo._.isObject(cc) && !Odigeo._.isEmpty(cc)) {
                Odigeo.trigger(this.widget.id + ':storedCardChanged', cc.name);
            }
        },
        isNewCreditCard: function(creditCardData) {
            return (
                Odigeo._.isEmpty(this.get('storedCCListValid')) ||
                Odigeo._.some(
                    this.get('storedCCListValid'),
                    Odigeo._.bind(function(creditCard) {
                        return (
                            !Odigeo._.isEqual(this.cardPropPicker(creditCard), this.cardPropPicker(creditCardData)) ||
                            this.checkFourLastDigits(creditCardData.ccnumber, creditCard.ccnumber)
                        );
                    }, this)
                )
            );
        },
        cardPropPicker: function(obj) {
            var propsToCheck = ['cardExpirationMonth', 'cardExpirationYear', 'code'];
            return Odigeo._.pick(obj, propsToCheck);
        },
        checkFourLastDigits: function(creditCardData, creditCard) {
            var visibleDigits = 4;
            return creditCardData.substring(creditCardData.length - visibleDigits) === creditCard.substring(creditCard.length - visibleDigits);
        },
        newChecker: function(creditCardData) {
            return this.isNewCreditCard(creditCardData);
        },
        saveCard: async function() {
            var creditCardData = Odigeo._.extend({}, this.get('creditCardData'), this.get('chosenCard'));
            var newCreditCard;
            var isNewCreditCard;
            let paymentInstrumentToken;
            creditCardData.ccnumber = fieldUtils.trimCreditCardNumber(creditCardData.ccnumber);
            newCreditCard = getCreditCardModel((this.get('storedCCListValid') || []).length === 0);
            isNewCreditCard = !Odigeo._.isEmpty(creditCardData) ?
                this.newChecker(creditCardData) : false;
            const instrumentTokenBody = {
                'number': creditCardData.ccnumber.replace(/\s|\/|-/g, ''),
                'holder': creditCardData.owner,
                'expirationMonth': creditCardData.cardExpirationMonth ?
                    creditCardData.cardExpirationMonth : creditCardData.expirationDateMonth,
                'expirationYear': creditCardData.cardExpirationYear ?
                    creditCardData.cardExpirationYear : creditCardData.expirationDateYearFormated,
            };
            if (isNewCreditCard && this.get('saveCardDataAcceptance') &&
                !this.get('selectedStorageCreditCard') && this.get('chosenMethod') === 'CREDITCARD') {
                paymentInstrumentToken = await paymentInstrument.generatePaymentInstrument(instrumentTokenBody);
                Odigeo._.each(creditCardMap, function(value, key) {
                    if (creditCardMap[key]) {
                        Odigeo.Utils.setNestedProperty(newCreditCard, creditCardMap[key], creditCardData[key]);
                    }
                });
                Odigeo.trigger(this.widget.id + ':addCreditCards', paymentInstrumentToken);
            }
        },
        saveCreditCardData: function(extendData) {
            this.set('creditCardData', Odigeo._.extend(this.get('creditCardData'), extendData));
            this.saveCreditCardFields(extendData);
        },
        saveCreditCardFields: function(extendData) {
            const cardFieldModels = this.get('cardFields');
            Odigeo._.each(cardFieldModels, (fieldModel, fieldName) => {
                if (Odigeo._.has(extendData, fieldName)) {
                    cardFieldModels[fieldName].update(extendData);
                }
            });
        },
    },
    selectors: {
        storedCardsWrapper: '.stored_cards_wrapper',
        cardStoredRow: '.cardstored_row',
        saveCardData: '[name="saveCardData"]',
        deleteCardProcessing: '.delete-card-processing',
        deleteCardSuccess: '.delete-card-success',
        creditCardForm: '.credit_card_form',
        savedCardRemove: '.saved_card_remove',
        creditCardTemplateList: '.stored_credit_card_template',
        creditCardRevampTemplateList: '.stored_credit_card_revamp_template',
        creditCardRevampCobaltTemplateList: '.stored_credit_card_revamp_cobalt_template',
        storedCvvContainer: '.stored_card_cvv_container',
        storageCreditCardContainer: '.storage_credit_card_container',
        storedCreditCard: '[name="storedCreditCard"]',
        storedCreditCardCVV: '[name="storedCvv3Digits"],[name="storedCvv4Digits"],[name="cvv2"]',
        storedCardLabel: '.stored_card_label',
        removeCardButton: '.remove_card_button',
        discardRemoveCardButton: '.discard_remove_card_button',
        savedCardRemoverTemplate: '.saved_card_remover_template',
        storedCardsHintContainer: '.stored_cards_hint_container',
        removeCCModal: '.remove_cc_modal',
        noValidCardMoreInfo: '.no_valid_card_more_info',
        paymentMethodCreditcard: '#payment-method-creditcard',
        storedCardsActive: '.stored_cards_active',
        newCardRevampSelectedTop: '.new_card_revamp_selected_top',
        newCardRevampSelectedBottom: '.new_card_revamp_selected_bottom',
        newCardRevampSelectedSides: '.new_card_revamp_selected_sides',
        noStoredCardText: '.no_stored_credit_card_text',
        storedCardText: '.stored_credit_card_text',
        paddingStoredCards: '.padding_stored_cards',
        mobileFormCvv: '.mobile_form_cvv',
        newCreditCardSelector: '.mobile_form_cvv_container .cvv2_field .cvv_field_container',
        mobileFormCvvContainer: '.mobile_form_cvv_container',
        paddingStoredCardsNoncc: '.padding_storedcards_noncc',
        checkboxPaddingRevamp: '.checkbox_padding_revamp',
    },
    view: {
        initView: function() {
            this.templates = {};
            Odigeo._.each([
                'savedCardRemoverTemplate',
                'creditCardTemplateList',
                'creditCardRevampTemplateList',
                'creditCardRevampCobaltTemplateList',
            ], function(template) {
                this.templates[template] = Odigeo._.template(this.$cachedSelectors[template].html(), this.tmplSettings);
            }, this);
            this.$cachedSelectors.saveCardData.on(Odigeo.Events.change + ' ' + Odigeo.Events.click,
                Odigeo._.bind(this.saveCardDataAcceptanceChanged, this));
        },
        toggleEvents: function(isBindEvents) {
            var onOff = isBindEvents ? 'on' : 'off';
            this.$cachedSelectors.storedCreditCard[onOff](Odigeo.Events.change, Odigeo._.bind(this.storedCreditCardSelected, this));
            this.$cachedSelectors.storedCreditCardCVV[onOff](Odigeo.Events.blur, Odigeo._.bind(this.cvvChanged, this));
            this.$cachedSelectors.savedCardRemove[onOff](Odigeo.Events.tap, Odigeo._.bind(this.openRemoveStoredCreditCard, this));
            this.$cachedSelectors.removeCCModal[onOff](Odigeo.Events.tap, stopPropagationAndGetTarget);
        },
        creditCardNotAllowedHint: function() {
            Odigeo._.each(this.$cachedSelectors.noValidCardMoreInfo, function(noValidCardMoreInfo) {
                Odigeo.UIElements.hint.enhance('payment', $(noValidCardMoreInfo), {
                    closeButton: {show: false},
                    generateHtml: true,
                    wrapperClass: 'od-payment-cardstored-hint od-hint-notitle',
                    arrowClass: 'od-hint-arrow-flex',
                    hintTriggerButton: {
                        hintTriggerButtonClass: 'od-payment-cardstored-hint-btn odf-text-xl',
                        hintTriggerButtonText: ']',
                    },
                    events: {
                        hover: true,
                        tap: false,
                    },
                });
            });
        },
        showHideSaveDataCardAgree: function(isVisible) {
            this.$cachedSelectors.cardSaverManager.toggleClass('odf-hidden', !isVisible);
        },
        openRemoveStoredCreditCard: function(e) {
            var creditCardId = stopPropagationAndGetTarget(e).data('id');
            var cc = Odigeo._.findWhere(this.model.get('storedCCListValid'), {id: creditCardId});
            onModalTransitioned.call(this, true, Odigeo._.bind(function() {
                $deleteHint = Odigeo.UIElements.hint.enhance('payment', this.templates.savedCardRemoverTemplate({cc: cc}), {
                    trigger: 'deleteStoredCreditCard',
                    events: {tap: true},
                });
                $deleteHint.find('.discard_remove_card_button').on(Odigeo.Events.tap, this.closeStoredCreditCardHint);
                $deleteHint.find('.remove_card_button').on(Odigeo.Events.tap, Odigeo._.bind(this.removeStoredCreditCardRequest, this));
                this.$cachedSelectors.storedCardsHintContainer.html($deleteHint);
                $deleteHint.trigger('showHint');
            }, this));
            trackingUtils.trackEvent('payment_details', 'delete_payment_clicks', false);
        },
        removeStoredCreditCardRequest: function(e) {
            var creditCardId;
            $deleteHint.attr('data-state', 'waiting');
            creditCardId = stopPropagationAndGetTarget(e).data('id');
            Odigeo.trigger(this.widget.id + ':deleteCreditCards', creditCardId);
            trackingUtils.trackEvent('payment_details', 'delete_payment_confirm', false);
        },
        removeStoredCreditCardSuccess: function() {
            if ($deleteHint instanceof $) {
                $deleteHint.attr('data-state', 'done');
                Odigeo._.delay(Odigeo._.bind(this.closeStoredCreditCardHint, this), 2000);
            }
        },
        closeStoredCreditCardHint: function() {
            if ($deleteHint instanceof $) {
                $deleteHint.trigger('hideHint');
            }
        },
        removeStoredCreditCardHintClosed: function() {
            onModalTransitioned.call(this, false, Odigeo._.bind(function() {
                this.$cachedSelectors.storedCardsHintContainer.empty();
                $deleteHint = null;
            }, this));
        },
        displayStoredCC: function() {
            var storedCCListValid = this.model.get('storedCCListValid');
            var listCCAllowed = Odigeo._.filter(storedCCListValid, function(cc) {
                return cc.isValid;
            });
            if (this.widget.options.isMobileRevamp) {
                this.model.set('chosenMethod', 'CREDITCARD');
            }
            var isCCSelected = this.model.get('chosenMethod') === 'CREDITCARD';
            var hasCCSaved = !!listCCAllowed.length;
            var noInvalidCC = (listCCAllowed.length === storedCCListValid.length) && hasCCSaved;
            if (Odigeo.AB.isMobileRevamp) {
                this.$cachedSelectors.root.toggleClass('od-stored-cards-visible-revamp', isCCSelected);
                this.$cachedSelectors.storedCardsActive.removeClass('od-payment-revamp-border-draw odf-box');
            }
            this.$cachedSelectors.root.toggleClass('od-stored-cards-visible', isCCSelected);
            if (this.widget.options.isMobileRevamp) {
                if (Odigeo.AB.isCssVariationMobile) {
                    this.$cachedSelectors.storedCardsWrapper.html(this.templates.creditCardRevampCobaltTemplateList({data: storedCCListValid}));
                } else {
                    this.$cachedSelectors.storedCardsWrapper.html(this.templates.creditCardRevampTemplateList({data: storedCCListValid}));
                }
            } else {
                this.$cachedSelectors.storedCardsWrapper.html(this.templates.creditCardTemplateList({data: storedCCListValid}));
            }
            this.updateDomSelectorsToCache();

            this.$cachedSelectors.creditCardForm.trigger('togglePanelByParameter', !hasCCSaved);
            this.creditCardNotAllowedHint();
            this.toggleEvents(hasCCSaved);
            this.showHideSaveDataCardAgree(!hasCCSaved);
            const $creditcard = this.$el.find(hasCCSaved ? '#creditcard-' + listCCAllowed[0].id : '#newCreditCard');
            $creditcard.trigger('change', [true]);
            this.trackPaymentsDisplayed(hasCCSaved, noInvalidCC);

            if (Odigeo.AB.isMobileRevamp && this.model.get('storedCCList').length) {
                this.$cachedSelectors.storedCardText.removeClass('odf-hidden');
                this.$cachedSelectors.noStoredCardText.addClass('odf-hidden');
                this.$cachedSelectors.paddingStoredCards.addClass('odf-space-inner-left-l');
                this.$cachedSelectors.paddingStoredCards.addClass('odf-space-inner-right-l');
                this.$cachedSelectors.paddingStoredCardsNoncc.removeClass('od-payment-revamp-border-draw-noncc');
                this.$cachedSelectors.checkboxPaddingRevamp.addClass('od-checkbox-padding-revamp');
            }
        },
        trackPaymentsDisplayed: function(hasCCSaved, noInvalidCC) {
            var trackDisplayedCcX = (hasCCSaved) ? '1' : '0';
            var trackDisplayedCcY = (noInvalidCC) ? '0' : '1';
            trackingUtils.trackEvent('payment_details', 'saved_payment_displayed_' + trackDisplayedCcX + '_' + trackDisplayedCcY);
        },
        fillCvv() {
            let $container = this.$cachedSelectors.cvv2;
            let updateCvv = () => this.cardFields.cvv2.execute('onBlur');
            if (this.widget.options.isDesktop) {
                $container = this.$cachedSelectors.storedCreditCardCVV;
                $container.val(this.model.get('cvv'));
                updateCvv = () => $container.trigger('blur');
            }
            if ($container.val()) {
                updateCvv();
            }
        },
        moveCvv($cvvContainer) {
            this.$cachedSelectors.mobileFormCvvContainer
                .toggleClass('odf-hidden', this.model.get('chosenMethod') !== 'CREDITCARD');
            if (this.widget.options.bigCvv) {
                return this.cardFields.cvv2.execute('appendTo', $cvvContainer)
                    .then(() => this.updateDomSelectorsToCache());
            }
            return Promise.resolve();
        },
        storedCreditCardClicked: Odigeo._.debounce(function(e, firedAutomatically) {
            this.storedCreditCardSelected(e, firedAutomatically);
        }, 50),
        cloneCardInNewPage(cc, firedAutomatically) {
            const storedCardSelected = Odigeo._.get(cc, 'id');
            if (storedCardSelected) {
                this.$cachedSelectors.newCreditCardSelector.addClass('odf-mobile-input-padding');
            }
            const $cvvContainer = storedCardSelected ? this.$el.find('.stored_card_cvv_' + cc.id) : this.$el.find('.mobile_form_cvv_container');
            return $cvvContainer;
        },
        changeSelectedNewStoredCard() {
            this.$cachedSelectors.storedCardLabel.removeClass('selected');
            this.paintBoxSelected(false);
        },
        storedCreditCardSelected: function(e, firedAutomatically) {
            const $selectedCreditCard = $(e.target);

            if (this.widget.options.isMobileRevamp && !firedAutomatically) {
                this.$cachedSelectors.methodSelector.prop('checked', false);
                this.$cachedSelectors.storedCreditCard.prop('checked', false);
                this.$cachedSelectors.paymentMethodCreditcard.prop('checked', false);

                this.$cachedSelectors.apmMethodSelector.removeClass('active');
                this.$cachedSelectors.noMethodSelected.addClass('odf-hidden');
            }

            $selectedCreditCard.prop('checked', true);

            if (Odigeo.AB.isCssVariationMobile) {
                this.$cachedSelectors.defaultCreditCardFormWrapper
                    .toggleClass('active',
                        this.$cachedSelectors.defaultCreditCardFormWrapper.find('#newCreditCard').is(':checked')
                    );
            }

            const $radioButton = stopPropagationAndGetTarget(e);
            const cc = Odigeo._.findWhere(this.model.get('storedCCListValid'), {id: $radioButton.data('id')});
            const $cvvContainer = this.cloneCardInNewPage(cc, firedAutomatically);

            this.model.changePaymentMethod('CREDITCARD');

            this.moveCvv($cvvContainer).then(() => {
                this.fillCvv();
                if (Odigeo.AB.isMobileRevamp) {
                    this.changeSelectedNewStoredCard();
                } else {
                    this.$cachedSelectors.storedCardLabel.removeClass('selected');
                }
                this.$cachedSelectors.creditCardForm.trigger('togglePanelByParameter', !$radioButton.val());
                this.showHideSaveDataCardAgree(!cc);
                if (Odigeo.AB.isMobileRevamp) {
                    this.changeSelectedNewStoredCard($radioButton);
                    this.$cachedSelectors.apmMethodSelector.removeClass('active');
                }
                $radioButton.siblings('.stored_card_label').addClass('selected');
                if (Odigeo.AB.isMobileRevamp && !$radioButton.val()) {
                    this.paintBoxSelected(true);
                }
                this.model.set('selectedStorageCreditCard', cc);
                if (!firedAutomatically) {
                    this.cardFields.cvv2.execute('onChange').then(() => {
                        this.cleanInputs(true);
                    });
                }
                if (!cc) {
                    trackingUtils.trackEvent('payment_details', 'new_credit_card_clicks', false);
                }
            });
        },

        paintBoxSelected: function(isPainted) {
            this.$cachedSelectors.newCardRevampSelectedTop.addClass('od-new-card-revamp-selected-top');

            this.$cachedSelectors.newCreditCardSelector.removeClass('odf-mobile-input-padding');
            if (!Odigeo.AB.isCssVariationMobile) {
                this.$cachedSelectors.mobileFormCvv
                    .toggleClass('od-newcard-revamp-sides od-background-color-revamp odf-space-inner-left-l ' +
                        'odf-space-inner-right-l od-background-color-revamp', isPainted);
                this.$cachedSelectors.newCardRevampSelectedTop.toggleClass('od-newcard-revamp-top', isPainted);
                this.$cachedSelectors.newCardRevampSelectedBottom.toggleClass('od-newcard-revamp-bottom', isPainted);
                this.$cachedSelectors.newCardRevampSelectedSides.toggleClass('od-newcard-revamp-sides', isPainted);

                // to remove
                this.$cachedSelectors.creditCardForm.addClass('od-cvv-padding');
            }
        },

        chosenMethodChanged: function() {
            if ( Odigeo.AB.isCssVariationMobile ) {
                if (this.model.get('chosenMethod') !== 'CREDITCARD') {
                    this.$cachedSelectors.storedCardLabel.removeClass('selected');
                    this.$cachedSelectors.storedCreditCard.prop('checked', false);
                }
            } else {
                if ( this.widget.options.isCreditCardLabelHidden ) {
                    if (this.model.get('chosenMethod') !== 'CREDITCARD') {
                        this.$cachedSelectors.storedCardLabel.removeClass('selected');
                        this.$cachedSelectors.storedCreditCard.prop('checked', false);
                        this.$cachedSelectors.creditCardForm.trigger('collapsePanel');
                    } else {
                        this.$cachedSelectors.paymentMethodCreditcard.prop('checked', true);
                    }
                }
            }
        },
        cvvChanged: function(e) {
            var $cvvInput = stopPropagationAndGetTarget(e);
            if (this.widget.options.isDesktop) {
                this.fields.setStateAndShowError($cvvInput, true);
            }
            this.model.saveCreditCardData({cvv2: $cvvInput.val() || ''});
            this.model.set('cvv', $cvvInput.val());
        },
        validateStoredCreditCardCvv: function() {
            var selectedStorageCreditCard = this.model.get('selectedStorageCreditCard') || {};
            var $cvvInput = this.$el.find('.stored_cvv_wrapper[data-id="' + selectedStorageCreditCard.id + '"] input');
            if ($cvvInput.length) {
                this.fields.setStateAndShowError($cvvInput, false);
            }
        },
        saveCardDataAcceptanceChanged: function(e) {
            var $acceptanceCheckbox = $(e.target);
            this.model.set('saveCardDataAcceptance', $acceptanceCheckbox.prop('checked'));
        },
    },
};
